export default __webpack_public_path__ + "static/media/youtube-blue.b5f7c6a9.svg";